import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/lib/auth';
import { lazyNamed } from '@/lib/lazy';

const FinesPage = lazyNamed(() => import('./pages'), 'FinesPage');
const CashRegistersPage = lazyNamed(() => import('./pages'), 'CashRegistersPage');
const DailySummaryPage = lazyNamed(() => import('./pages'), 'DailySummaryPage');

/**
 * Staff routes for features/fines. Paths are relative to /staff. Replace a placeholder by building the page in this folder
 * and pointing the lazy import at it; keep the permission wrapper.
 */
export const finesRoutes: RouteObject[] = [
  { path: 'fines', element: <RequirePermission permission={['updatecharges']}><FinesPage /></RequirePermission> },
  { path: 'fines/registers', element: <RequirePermission permission={['cash_management']}><CashRegistersPage /></RequirePermission> },
  { path: 'fines/daily', element: <RequirePermission permission={['updatecharges', 'cash_management']}><DailySummaryPage /></RequirePermission> },
];
